var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.843,
    height: 16.378,
    viewBox: "0 0 15.843 16.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-button-svgrepo-com",
    transform: "translate(-0.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65439",
    "data-name": "Path 65439",
    d: "M14.133,19.1v3.741H2.689V19.1H.489v4.841a1.1,1.1,0,0,0,1.1,1.1h13.64a1.1,1.1,0,0,0,1.1-1.1V19.1Z",
    transform: "translate(0 -8.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65440",
    "data-name": "Path 65440",
    d: "M11.838,10.067,8.689,6.262s-.479-.452.04-.452H10.5V.27S10.433,0,10.84,0h2.5c.293,0,.286.227.286.227V5.7h1.638c.63,0,.156.474.156.474s-2.679,3.557-3.053,3.93A.349.349,0,0,1,11.838,10.067Z",
    transform: "translate(-3.628)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/download-button.2f2731717a59bed62cf540b7a77d8c4e.svg";
export { ForwardRef as ReactComponent };